module.exports = "dist/images/components-image-shape-control-blob1.8e07b2a.png";